var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { Icon, Tooltip, Snackbar, Button } from '@cimpress/react-components';
import * as colors from '@cimpress/react-components/lib/colors';
import { connect } from 'react-redux';
import CustomBulkExport from './CustomBulkExport';
import CustomUpload from './CustomUpload';
import { toggleCustomBulkExportModal, onExportTypeChange, onExportTypeSubmit, toggleTasksModal, getTasksInfo, toggleIsExported } from '../../actions/BulkExportAction';
import TasksModal from './TasksModal';
import { exportExcel } from '../../services/exportPricingExcel';
import cloneDeep from 'lodash/cloneDeep';
import { getToken } from '../../services/token';
import jwtDecode from 'jwt-decode';
import WebsiteDownload from './WebsiteDownload';

function mapStateToProps(state, ownProps) {
  var tabbedView = ownProps.tabbedView;
  return {
    tabbedView: tabbedView,
    bulkExport: state.bulkExport,
    pricingGrid: state.pricingGrid,
    priceExplorerGrid: state.priceExplorerGrid
  };
}

var mapDispatchToProps = {
  toggleCustomBulkExportModal: toggleCustomBulkExportModal,
  onExportTypeChange: onExportTypeChange,
  onExportTypeSubmit: onExportTypeSubmit,
  toggleTasksModal: toggleTasksModal,
  getTasksInfo: getTasksInfo,
  toggleIsExported: toggleIsExported
};
var connector = connect(mapStateToProps, mapDispatchToProps);

var Export =
/** @class */
function (_super) {
  __extends(Export, _super);

  function Export(props) {
    var _this = _super.call(this, props) || this;

    _this.componentDidCatch = function (error, info) {
      if (_this.props.pricingGrid.logger) {
        _this.props.pricingGrid.logger.logError({
          message: 'Error occurred in Export Error Boundary',
          error: {
            errorInfo: error,
            info: info
          }
        }, 'Export Grid');
      }
    };

    _this.submitExport = function (value) {
      var _a = _this.props.pricingGrid,
          skuData = _a.skuData,
          logger = _a.logger,
          showCompetitivePricing = _a.showCompetitivePricing,
          shippingConfiguration = _a.shippingConfiguration;
      var tabbedView = _this.props.tabbedView;

      if (value === 'pricingGrid') {
        var skuDetails = Object.values(skuData)[0];
        var selectedRow = skuDetails.selectedRow,
            selectedColumn = skuDetails.selectedColumn;

        if (skuDetails && skuDetails.state !== 'fullyResolved') {
          _this.props.toggleIsExported(false);
        } else {
          var _b = _this.props.priceExplorerGrid,
              rowData = _b.rowData,
              headers = _b.headers;
          var clonedRowData = cloneDeep(rowData);
          var isExported = exportExcel(clonedRowData, headers, selectedRow, selectedColumn, skuData, logger, showCompetitivePricing, shippingConfiguration, tabbedView);

          _this.props.toggleIsExported(isExported);
        }
      }

      _this.props.onExportTypeSubmit(value);
    };

    _this.getAccountId = function (decodedJWT) {
      return decodedJWT['https://claims.cimpress.io/account'];
    };

    _this.getEmailId = function (decodedJWT) {
      return decodedJWT['https://claims.cimpress.io/email'];
    };

    _this.toggleWebsiteDownload = function (value) {
      _this.setState({
        showWebsiteDownload: value
      });
    };

    _this.superUsers = ['prince.bansal@cimpress.com', 'vinit.kanani@cimpress.com', 'shivam.bajpai@cimpress.com', 'skondusennappan@cimpress.com', 'abancila@cimpress.com', 'melissa.eckert@cimpress.com'];
    _this.state = {
      showTooltip: _this.props.bulkExport.open || false,
      showWebsiteDownload: false
    };
    return _this;
  }

  Export.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;

    if (prevProps.bulkExport.isExported !== this.props.bulkExport.isExported && !this.props.bulkExport.isExported) {
      setTimeout(function () {
        _this.props.toggleIsExported(true);
      }, 3000);
    }
  };

  Export.prototype.render = function () {
    var _this = this;

    var _a = this.props.pricingGrid,
        skuData = _a.skuData,
        isProduction = _a.isProduction;
    var sku = Object.keys(skuData)[0] || undefined;
    var sellerId = sku && skuData[sku] && skuData[sku].sellerId;
    var rowData = this.props.priceExplorerGrid.rowData;
    var isExported = this.props.bulkExport.isExported;
    var decodedJWT = jwtDecode(getToken());
    var accountId = this.getAccountId(decodedJWT);
    var userEmail = this.getEmailId(decodedJWT);
    var skuDetails = Object.values(skuData)[0];
    return React.createElement(React.Fragment, null, React.createElement(Tooltip, {
      direction: "top",
      contents: "Export"
    }, React.createElement(Snackbar, {
      show: !isExported,
      bsStyle: "danger",
      delay: 3000
    }, "Error in downloading Pricing Grid. " + (skuDetails && skuDetails.state !== 'fullyResolved' ? 'Please select all the attributes to download the pricing grid.' : '')), React.createElement(Tooltip, {
      tooltipStyle: {
        maxWidth: '350px'
      },
      direction: "bottom",
      variety: "popover",
      className: "tooltip-export",
      show: this.state.showTooltip,
      onClickOutside: function onClickOutside() {
        _this.setState({
          showTooltip: false
        });
      },
      contents: React.createElement("div", null, React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "export-list-div",
        onClick: function onClick() {
          _this.setState({
            showTooltip: false
          });

          _this.submitExport('pricingGrid');
        }
      }, "Displayed Pricing Grid"), React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "export-list-div",
        onClick: function onClick() {
          _this.setState({
            showTooltip: false
          });

          _this.submitExport('bulkExport');
        }
      }, "Custom Attribute Selections"), React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "export-list-div",
        onClick: function onClick() {
          _this.setState({
            showTooltip: false
          });

          _this.submitExport('customUpload');
        }
      }, "Custom File Upload"), (accountId === 'noS5wU4XH2WRmkaqKqTpfH' || this.superUsers.includes(userEmail.toLowerCase())) && sellerId === 'yy48m4r8x5' ? // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "export-list-div",
        onClick: function onClick() {
          _this.setState({
            showWebsiteDownload: true,
            showTooltip: false
          });
        }
      }, "Website Price and Cost") : null, React.createElement("hr", {
        style: {
          marginTop: '6px',
          marginBottom: '6px'
        }
      }), React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: "export-list-div",
        onClick: function onClick() {
          _this.setState({
            showTooltip: false
          });

          _this.props.getTasksInfo();
        }
      }, "Download Status"))
    }, React.createElement(Button, {
      disabled: !(rowData && rowData.length > 0),
      className: "shippingButton export-button",
      onClick: function onClick() {
        _this.setState({
          showTooltip: true
        });
      }
    }, React.createElement(Icon, {
      color: colors.teal.base,
      name: "download-3-f"
    })))), React.createElement(Snackbar, {
      show: !isExported,
      bsStyle: "danger",
      delay: 3000
    }, "Error in downloading Pricing Grid. " + (skuDetails && skuDetails.state !== 'fullyResolved' ? 'Please select all the attributes to download the pricing grid.' : '')), React.createElement(TasksModal, null), React.createElement(CustomBulkExport, null), React.createElement(CustomUpload, {
      onGetAccessToken: this.props.pricingGrid.onGetAccessToken
    }), React.createElement(WebsiteDownload, {
      sku: sku,
      toggleShowWebsite: this.toggleWebsiteDownload,
      showWebsiteDownload: this.state.showWebsiteDownload,
      isProduction: isProduction
    }));
  };

  return Export;
}(Component);

export default connector(Export);